import { render } from "./DeliveryComponent.vue?vue&type=template&id=319d270f&scoped=true"
import script from "./DeliveryComponent.vue?vue&type=script&lang=js"
export * from "./DeliveryComponent.vue?vue&type=script&lang=js"

import "./DeliveryComponent.vue?vue&type=style&index=0&id=319d270f&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319d270f"]])

export default __exports__